function myFunction(dropdownId) {
  var dropdown = document.getElementById(dropdownId);
  dropdown.classList.toggle("show");

  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
    if (!event.target.matches('.location-button')) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      for (var i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  }
}

var el = document.querySelectorAll('.t4s-about-us');
for (var i=0; i < el.length; i++) {
    const id = el[i].querySelector("h4").innerText.trim().toLocaleLowerCase().replace(/\s+/g, '-');
    el[i].setAttribute("id", id);
}

document.querySelector('.redirect-links').addEventListener('click', function(e) {
  e.preventDefault();
  if (e.target.classList.contains('redirect-link')) {
    const allLinks = document.querySelectorAll('.redirect-link');
    for (var i = 0; i < allLinks.length; i++) {
      allLinks[i].className = allLinks[0].className.replace(" active", "");
      e.target.classList.add("active");
    }
    const id = e.target.getAttribute('href').split('#');
    var element = document.getElementById(id[1]);
    var ma = window.matchMedia( "(max-width: 767px)" );
    if(ma.matches) {
      var headerOffset = 130;
    } else {
      var headerOffset = 200;
    }
        var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });     
  }

  
});

